import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "./css/TableReg.css";
import 'bootstrap/dist/css/bootstrap.css';
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import { DBContext } from './DBContext'
import axios from 'axios'
import tick from './images/icons/check.png'
import cross from './images/icons/cross.png'
import Select, { components } from 'react-select';
import SideNavMob from './SideNavMob'
import NavBarMobile from './Mobile/NavBar'

function TableReg({ asModal = false, propState = null, onClose = null }) {

    const [collapsed, setCollapsed] = useState(false);
    const [Table_num, setTable_num] = useState("");
    const [Table_Capacity, setTable_Capacity] = useState("");
    const [Table_onlineName, setTable_onlineName] = useState("");
    const [Table_info, setTable_info] = useState("");
    const [initialTableOnlineName, setInitialTableOnlineName] = useState("");
    const [Database, setDatabase] = useState(localStorage.getItem('DB'));
    const [imgCode, setImgCode] = useState(localStorage.getItem('imgCode'));
    const [company, setCompany] = useState(localStorage.getItem('Company'));
    const location = useLocation(null)

    const { logginedDB, sideNavState, sideNavStateFunc } = useContext(DBContext);

    const api_base_url = process.env.REACT_APP_API_BASE_URL

    const [tableId, setTableId] = useState(null)
    const [area, setArea] = useState(null)
    const [from, setFrom] = useState(null)
    const [tableCount, setTableCount] = useState(1);

    useEffect(() => {
        const stateData = asModal ? propState : location.state;
        if (stateData) {
            setTableId(stateData.id)
            setArea(stateData.area)
            setFrom(stateData.from)
        }
    }, [location, asModal, propState])
    useEffect(() => {
        if (Table_num && !Table_onlineName) {
            setTable_onlineName(Table_num);
            handleCheckAvailableName()
        }
    }, [Table_num]);

    const handleModifyTable = async () => {
        try {
            const response = await axios.get(`${api_base_url}/getTableDetails/${tableId}/${logginedDB}`)
            if (response.status == 200) {
                setTable_num(response.data[0].Table_num)
                setTable_info(response.data[0].Table_info)
                setTable_onlineName(response.data[0].Table_onlineName)
                setInitialTableOnlineName(response.data[0].Table_onlineName)
                setTable_Capacity(response.data[0].Table_Capacity)

            }
        } catch (error) {
            //(error);
        }
    }

    useEffect(() => {
        if (tableId) {
            handleModifyTable()
        }
    }, [tableId])

    const navigate = useNavigate();

    const handleCancel = () => {
        if (asModal && onClose) {
            onClose();
        } else if (from) {
            navigate('/tableview')
        } else {
            navigate('/basemenureg', {
                state: 'tableCancel'
            })
        }
    }

    const [selectedOption, setSelectedOption] = useState(null)

    const handleSaveTable = async () => {
        console.log("the ");

        // if (!Table_num || !Table_Capacity) {
        //     alert("Please fill in all fields.");
        //     return;
        // }
        if (Table_onlineName === 0 || !Table_onlineName) {
            return alert("Table online name is must!")
        }

        if (Table_onlineName !== initialTableOnlineName && (avail === 0 || !avail)) {
            return alert("Duplicate name!")
        }

        if (!Table_Capacity) {
            return alert("Table capacity is must!")
        }

        const currentDate = new Date().toISOString().split('T0')[0];

        const data = {
            Table_num: Table_num,
            Table_Capacity: Table_Capacity || '',
            Table_onlineName: Table_onlineName,
            Table_info: Table_info,
            currentDate: currentDate,
            count: tableCount
        };
        console.log(data, "data");

        try {
            let response;
            console.log("table reg trial");

            if (from && from !== "tableview") {
                response = await fetch(`${api_base_url}/TempTableReg/${from}/${logginedDB}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                });
            } else if (tableId) {
                response = await fetch(`${api_base_url}/TableRegUpdate/${tableId}/${logginedDB}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                });
            } else {
                console.log(selectedOption.value, "selectedOption.value");

                response = await fetch(`${api_base_url}/TableReg/${selectedOption.value}/${logginedDB}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                });
            }

            if (response.ok) {
                if (asModal && onClose) {
                    onClose(true); // pass true to indicate success
                } else if (from) {
                    navigate('/tableview')
                } else {
                    navigate('/basemenureg', {
                        state: 'tableCancel'
                    })
                }
            } else {
                console.error("Failed to submit data");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    }

    const [avail, setAvail] = useState(null)

    const handleCheckAvailableName = async (val) => {
        if (val === '') return setAvail(null)
        try {
            const response = await axios.get(`${api_base_url}/checkAvailableTableName/${val}/${logginedDB}`)
            if (response.status === 200) {
                const checked = response.data.isAvailable
                if (checked == 0) {
                    setAvail(1)
                } else {
                    setAvail(0)
                }
            }
        } catch (error) {
            //(error);
        }
    }
    // Table_onlineName === '' ? setTable_onlineName(Table_num) :setTable_onlineName() ;

    // if Table_onlineName === '' ? setTable_onlineName(Table_num)
    // Table_onlineName === '' && setTable_onlineName(Table_num);

    // if (Table_onlineName === '') {
    //     setTable_onlineName(Table_num)
    // }

    // console.log("test ", Table_onlineName );

    const handleTable_num = (event) => {
        setTable_num(event.target.value);
    };
    const handleTable_Capacity = (event) => {
        setTable_Capacity(event.target.value);

    };
    const handleTable_onlineName = (event) => {
        setTable_onlineName(event.target.value);
        handleCheckAvailableName(event.target.value)
    };
    const handleTable_info = (event) => {
        setTable_info(event.target.value);
    };


    const [sideNav, setSideNav] = useState(false)

    const handleSideNav = (state) => {
        setSideNav(state)
    }
    const [falseState, setFalseState] = useState(null)

    useEffect(() => {
        const handleWindowResize = () => {
            if (window.innerWidth <= 768) {
                setCollapsed(true);
            } else {
                setCollapsed(false);
            }
        };

        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    const customMDpx = window.innerWidth >= 768;

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            fontSize: '.9em',
            // fontFamily: 'Poppins',
            textAlign: 'left',
            backgroundColor: state.isSelected ? '#c8cbcf' : '#FFF',
            color: state.isFocused ? '#000' : '#000',
            cursor: 'pointer', // Add cursor pointer on hover
            ':hover': {
                backgroundColor: '#c8cbcf',
                color: '#000',
            },
            ':active': {
                ...provided[':active'],
                backgroundColor: '#c8cbcf'
            }
        }),
        control: (provided, state) => ({
            ...provided,
            width: '100%',
            // height: '2.5rem',
            minHeight: '2rem',
            fontSize: '1em',
            borderRadius: selectedOption ? '0rem' : '.313rem', // Adjust this value as needed
            padding: '0', // Ensure no extra padding is added
            // border: 'none',
            fontWeight: '500',
            // color: 'white !important', // Set text color to white
            backgroundColor: 'transparent', // Change this to 'transparent' for a clear background
            boxShadow: 'none', // Remove the blue focus shadow
            border: selectedOption ? 'none' : '1px solid #ccc', // Optional: add custom border on focus
            borderBottom: selectedOption ? '1px solid #ccc' : '1px solid #ccc',
            '&:hover': {
                borderBottom: '1px solid #c8cbcf', // Optional: border on hover
            }
            // border: state.selectValue ? '1px solid #ccc' : 'none', // Apply full border if no selected option
            // borderBottom: state.selectValue ? '2px solid #c8cbcf' : '1px solid #ccc', // Apply bottom border when option is selected
            // '&:hover': {
            // 	border: state.selectValue ? '1px solid #ccc' : 'none', // Apply full border on hover if no option selected
            // 	borderBottom: state.selectValue ? '2px solid #c8cbcf' : 'none', // Apply bottom border on hover
            // }
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '2.25rem',
            minHeight: '2rem',
            padding: '0 8px', // Center the text vertically
            display: 'flex',
            //   color: '#fff',
            alignItems: 'center',
            fontSize: '.9rem'
        }),
        input: (provided) => ({
            ...provided,
            height: '2.25rem',
            minHeight: '2rem',
            margin: '0',
            padding: '0',
            //   color: '#fff',
            fontSize: '.9rem'
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '2.25rem',
            display: 'flex',
            alignItems: 'center',
            padding: '.5rem',
            paddingTop: '0',
            paddingBottom: '0'
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0', // Remove padding to center the icon
            width: '1rem',
            marginLeft: '.5rem',
            //   color: '#fff',
            cursor: 'pointer',
        }),
        placeholder: (provided) => ({
            ...provided,
            margin: '0',
            fontSize: '1em',
            //   color: '#fff',
            //   fontFamily: 'poppins'
        }),
        menu: (provided) => ({
            ...provided,
            //   borderRadius: '.1rem', // Adjust this value as needed
        }),
        singleValue: (provided) => ({
            ...provided,
            // color: 'white', // Set selected option text color to white
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 99999,
        }),
    };

    // const options = [
    // 	{ value: '1', label: 'person' },
    // 	{ value: '2', label: 'sadasd' },
    // ];

    const [options, setOptions] = useState([])

    useEffect(() => {
        if (from && from !== "tableview") {
            const matchedOption = options.find(option => option.value === from);
            if (matchedOption) {
                setSelectedOption(matchedOption);
            } else {
                setSelectedOption(null); // Reset if no match
            }
        }
    }, [from, options]);

    const handleGetAreas = async () => {
        try {
            const response = await axios.get(`${api_base_url}/getAreaInfo/${logginedDB}`)
            if (response.status == 200) {
                const transformedData = response.data.map(area => ({
                    value: area.Area_id,
                    label: area.AreaName
                }));

                setOptions(transformedData);
            }
        } catch (error) {
            //(error);
        }
    }

    useEffect(() => {
        handleGetAreas()
    }, [])

    const handleGetTableNum = async () => {
        try {
            const response = await axios.get(`${api_base_url}/getTableNo/${selectedOption.value}/${logginedDB}`)
            if (response.status == 200) {
                setTable_num(response.data.nextTableNo);
            }
        } catch (error) {
            //(error);
        }
    }

    useEffect(() => {
        if ((selectedOption && !from) || (selectedOption && from === "tableview")) {
            handleGetTableNum()
        }

    }, [selectedOption])

    const handleGetTempTableNum = async () => {
        try {
            const response = await axios.get(`${api_base_url}/getTempTableNo/${from}/${logginedDB}`)
            if (response.status == 200) {
                setTable_num(response.data.nextTableNo);
            }
        } catch (error) {
            //(error);
        }
    }

    useEffect(() => {
        if (from && from !== "tableview") {
            handleGetTempTableNum()
        }
    }, [from])

    const handleChange = (option) => {
        setSelectedOption(option)
    }

    const renderFormBody = () => (
        <>
            {
                (!tableId && !area) && (
                    <div className='mb-2'>
                        <div className="w-1/2">
                            <span className="block font-semibold text-gray-700 text-sm mb-1.5">Select Area</span>
                            <Select
                                styles={customStyles}
                                placeholder='Area'
                                value={selectedOption}
                                options={options}
                                onChange={(selectedOption) => handleChange(selectedOption)}
                                isDisabled={from && from !== "tableview"}
                                menuPortalTarget={asModal ? document.body : null}
                                menuPosition={asModal ? 'fixed' : 'absolute'}
                            />
                        </div>
                    </div>
                )
            }
            {
                (selectedOption || tableId) && (
                    <div className='flex flex-col gap-5 text-[1rem]'>
                        <div className='w-full flex gap-5'>
                            {!tableId ? (
                                <div className='w-1/2 flex flex-col gap-1.5'>
                                    <span className="font-semibold text-gray-700 text-sm">No of Tables to Create</span>
                                    <input className="p-3 bg-white border border-gray-200 rounded-xl focus:ring-4 focus:ring-gray-900/10 focus:border-gray-900 shadow-sm outline-none transition-all" type="number" min="1" value={tableCount} onChange={(e) => setTableCount(Math.max(1, parseInt(e.target.value) || 1))} />
                                </div>
                            ) : (
                                <div className='w-1/2 flex flex-col gap-1.5 Hidden'>
                                    <span className="font-semibold text-gray-700 text-sm">Table No</span>
                                    <input className="p-3 bg-gray-100 border border-transparent rounded-xl text-gray-700 shadow-sm" type="text"
                                        value={Table_num}
                                        disabled
                                    />
                                </div>
                            )}
                            <div className='w-1/2 flex flex-col gap-1.5'>
                                <span className="font-semibold text-gray-700 text-sm">No of Persons</span>
                                <input className="p-3 bg-white border border-gray-200 rounded-xl focus:ring-4 focus:ring-gray-900/10 focus:border-gray-900 shadow-sm outline-none transition-all" type="number" value={Table_Capacity} onChange={handleTable_Capacity} />
                            </div>
                        </div>
                        <div className='w-full flex gap-5'>
                            <div className='w-1/2 flex flex-col gap-1.5'>
                                <span className="font-semibold text-gray-700 text-sm">Online Display Name</span>
                                <div className='w-full flex items-center bg-white border border-gray-200 rounded-xl overflow-hidden focus-within:ring-4 focus-within:ring-gray-900/10 focus-within:border-gray-900 shadow-sm transition-all'>
                                    <input className="w-full p-3 bg-transparent border-none outline-none" type="text" value={Table_onlineName} onChange={handleTable_onlineName} />
                                    <div className='w-max flex justify-center items-center px-4'>
                                        {avail == 1 && <img className='w-5 h-5 opacity-80' src={tick} alt="" />}
                                        {avail == 0 && <img className='w-5 h-5 opacity-80' src={cross} alt="" />}
                                    </div>
                                </div>
                            </div>
                            <div className='w-1/2 flex flex-col gap-1.5'>
                                <span className="font-semibold text-gray-700 text-sm">Extra Information</span>
                                <input className="p-3 bg-white border border-gray-200 rounded-xl focus:ring-4 focus:ring-gray-900/10 focus:border-gray-900 shadow-sm outline-none transition-all" type="text" value={Table_info} onChange={handleTable_info} />
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );

    if (asModal) {
        return (
            <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/5 backdrop-blur-[1px]" onClick={handleCancel}>
                <div className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.25)] border border-white/20 w-full max-w-2xl flex flex-col transform transition-all scale-100" onClick={(e) => e.stopPropagation()}>
                    {/* Modal Header */}
                    <div className="bg-white rounded-t-2xl px-8 py-3 flex justify-between items-center border-b border-gray-100">
                        <h2 className="text-xl font-bold text-gray-800 tracking-tight">{area ? area : (from && from !== "tableview") ? 'Add Temporary Table' : 'Add Table'}</h2>
                        <button onClick={handleCancel} className="text-gray-400 hover:text-gray-600 transition-colors rounded-full p-1.5 hover:bg-gray-100">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </button>
                    </div>
                    {/* Modal Body */}
                    <div className="p-8 flex flex-col gap-6 font-nunito bg-gray-50/30 ">
                        {renderFormBody()}
                    </div>
                    {/* Modal Footer */}
                    <div className="px-8 py-3 bg-white rounded-b-2xl border-t border-gray-100 flex justify-end gap-3">
                        <button className='px-6 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all shadow-sm focus:ring-4 focus:ring-gray-100 outline-none' onClick={handleCancel}>Cancel</button>
                        <button className='px-6 py-2.5 text-sm font-semibold text-white bg-gray-900 rounded-xl hover:bg-black transition-all shadow-[0_4px_14px_0_rgba(0,0,0,0.2)] focus:ring-4 focus:ring-gray-300 outline-none' onClick={handleSaveTable}>Save Table</button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='w-screen h-screen flex flex-col overflow-hidden'>
            <div className='w-full h-full overflow-hidden hidden sm:flex sm:flex-col'>
                <SherDineNav sideNav={(state) => handleSideNav(state)} falseState={falseState} />
                <div className='w-full bg-[#f5f5f5] flex-grow flex gap-3 overflow-hidden'>
                    <div className='w-max h-full z-[9999]'>
                        <SideNav focus={'Menu'} state={sideNav} falseState={(state) => setFalseState(state)} />
                    </div>
                    <div className='w-full h-full flex flex-col pr-3 pl-0 pb-3 pt-0 gap-3 overflow-hidden'>
                        <div className="pr-3 h-max w-full bg-[#fff] borderBottom">
                            <TopRootDiv image={'Menu Management'} root={['Menu Management', 'Base Menu']} section={(from && from !== "tableview") ? 'Add Temporary Table' : 'Add Table'} />
                        </div>
                        <div className='w-full h-full flex flex-col font-nunito overflow-hidden'>
                            <div className='TableAreaReg_areaDetails_span bg-white rounded-t-md border-b'>
                                <span>{area ? area : (from && from !== "tableview") ? 'Temporary Table Details' : 'Table Details'}</span>
                                <div className=' AddItem_Buttons AddItem_Buttons_TableAreaReg text-nowrap'>
                                    <button className='loginBorder text-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3' onClick={handleCancel}>Cancel</button>
                                    <button className='loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3' onClick={handleSaveTable}>Save</button>
                                </div>
                            </div>
                            <div className='p-4 flex flex-col bg-white gap-4 flex-grow h-full rounded-b-md shadow-sm border border-t-0 border-gray-200 overflow-y-auto'>
                                {renderFormBody()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TableReg
